module.exports = __webpack_public_path__ + "static/media/Stellar Queen Hydraulic Bed Base - 155x205 cm_Cream.44665c23.png";